const FloatingAppBanner = () => {
  return (
    <a
      href="https://apps.apple.com/id/app/spended-money-habit-tracker/id6761374562"
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: 'fixed',
        bottom: '24px',
        right: '24px',
        zIndex: 9999,
        cursor: 'pointer',
      }}
      className="floating-app-banner"
    >
      <img
        src="/spended-app-banner.png"
        alt="Spended – Money Habit Tracker"
        style={{
          width: '300px',
          height: 'auto',
          borderRadius: '0',
          boxShadow: 'none',
          display: 'block',
          transition: 'transform 0.2s ease',
        }}
        onMouseEnter={e => {
          e.currentTarget.style.transform = 'translateY(-4px)';
        }}
        onMouseLeave={e => {
          e.currentTarget.style.transform = 'translateY(0)';
        }}
      />
    </a>
  );
};

export default FloatingAppBanner;
